import styled from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//components
import { SectionPanel } from '@/components/Grid/Panel';

export const SidePanels = styled(SectionPanel)`
  margin-top: 0px;
`;

export const CustomSidePanels = styled(SectionPanel)`
  margin-top: 0px;

  ${screen.md} {
    margin-top: 40px;
  }
  ${screen.lg} {
    margin-top: 60px;
  }
  ${screen.xxlg} {
    margin-top: 80px;
  }
`;

export const PageWrapper = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
`;

export const VideoWrapper = styled.div`
  margin: 0 auto;
  height: 280px;
  width: 100%;

  video {
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
    margin: auto;
  }

  & > div > button {
    padding: 0;
  }

  & > div > div > button {
    transform: translateX(-30px);
  }

  ${screen.md} {
    align-self: center;
    height: 191px;
  }

  ${screen.lg} {
    height: 278px;
  }

  ${screen.xxlg} {
    height: 390px;
  }
`;
